import React from 'react';
import { chatStyles } from '@zonofi/chats-common';
import Icon from 'react-native-easy-icon';
import { FileParams, theme } from '@zonofi/common';
import { ActivityIndicator } from 'react-native-paper';
import { useMediaHandler } from '../helpers/handle-media';

export const DocumentView: React.FC<FileParams> = (props) => {
  const { filename = '' } = props;
  const ext = filename.slice(filename.lastIndexOf('.') + 1).toUpperCase();

  const { handleMedia, isLoading } = useMediaHandler({
    ...props,
  });

  const openFile = async () => {
    await handleMedia('open');
  };

  const download = async (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => {
    event.stopPropagation();
    await handleMedia('download');
  };

  return (
    <div
      className="document-view"
      style={{ borderColor: `${theme.text.secondary}30` }}
      onClick={openFile}
    >
      <div className="document-view__icon">
        <Icon
          name="file"
          type="feather"
          size={18}
          color={theme.text.secondary}
        />
      </div>
      <div className="document-view__info">
        <div
          className="document-title"
          style={chatStyles.fontSemiBold14Primary}
        >
          {filename}
        </div>
        <div className="document-ext" style={chatStyles.fontRegular10Secondary}>
          {ext}
        </div>
      </div>
      <div className="document-view__download" onClick={download}>
        {isLoading ? (
          <ActivityIndicator size={16} color={theme.text.secondary} />
        ) : (
          <Icon
            name="download"
            type="material-community"
            size={18}
            color={theme.text.secondary}
          />
        )}
      </div>
    </div>
  );
};
